"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
const tokens = {"rotating":"CircularProgress_q8nQr","vlm-circular-progress-rotating":"CircularProgress_3a7o7"};
tokens._getCss = function () {return `/* imported from CircularProgress.css */ @keyframes CircularProgress_3a7o7 { from { transform: rotate(0deg); } to { transform: rotate(360deg); } } .CircularProgress_q8nQr { animation: CircularProgress_3a7o7 550ms linear infinite; } `;};
tokens._module = (typeof module !== "undefined") ? module : {id:"./common/src/svg/sync/CircularProgress_css.js"};
exports["default"] = tokens;